import { Flame } from "lucide-react";
import { STR } from "@/data/i18n";
import { useLang } from "@/lib/lang";

const Row = ({ items }) => (
    <div className="flex shrink-0 items-center">
        {items.map((item, i) => (
            <span key={`${item}-${i}`} className="flex items-center">
                <span
                    className={`whitespace-nowrap px-7 text-xl font-bold uppercase tracking-[0.22em] md:text-2xl ${
                        i % 2 === 0 ? "text-zinc-600" : "stroke-text"
                    }`}
                >
                    {item}
                </span>
                <Flame className="h-4 w-4 shrink-0 text-orange-600/70" aria-hidden="true" />
            </span>
        ))}
    </div>
);

export const Marquee = () => {
    const { lang } = useLang();
    const items = STR.marquee[lang];
    return (
        <div
            data-testid="marquee"
            className="relative overflow-hidden border-y border-white/5 bg-[#0c0c0c] py-6"
            aria-hidden="true"
        >
            <div className="animate-marquee flex w-max">
                <Row items={items} />
                <Row items={items} />
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0c0c0c] to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0c0c0c] to-transparent" />
        </div>
    );
};
